const routes = [
  {
    path: 'blend-bubble',
    name: 'blend-bubble',
    component: () => import(/* webpackChunkName: "blend-bubble" */ '@/modules/blend-bubble/index.vue'),
    children: [
      {
        path: '',
        name: 'blend-bubble',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/blend-bubble/demo1.vue')
      },
      {
        path: 'demo1',
        name: 'demo1',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/blend-bubble/demo1.vue')
      },
      {
        path: 'code',
        name: 'code',
        component: () => import(/* webpackChunkName: "code" */ '@/modules/blend-bubble/code.vue')
      },
    ]
  },
];

export default routes;